
import api from "./api";

const NotificationService = {
  getByUserId: async (userId) => {
    const res = await api.get(`/notification/getByUser/${userId}`);
    return res.data;
  },

  markAsRead: async (id) => {
    return await api.put(`/notification/markAsRead/${id}`);
  }
};

export default NotificationService;